'use strict';

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
var BOX = exports.BOX = 'CAtomBox';
var CAROUSEL_ARROW = exports.CAROUSEL_ARROW = 'CAtomCarouselArrow';
var CAROUSEL_DOT = exports.CAROUSEL_DOT = 'CAtomCarouselDot';
var CLOSE_BUTTON = exports.CLOSE_BUTTON = 'CAtomCloseButton';
var ICON = exports.ICON = 'CAtomIcon';
var IMAGE = exports.IMAGE = 'CAtomImage';
var ILLUSTRATION = exports.ILLUSTRATION = 'CAtomIllustration';
var INPUT = exports.INPUT = 'CAtomInput';
var PAGE = exports.PAGE = 'CAtomPage';
var PLYR_WRAPPER = exports.PLYR_WRAPPER = 'CAtomPlyrWrapper';
var TEXT = exports.TEXT = 'CAtomText';
var TEXT_REDRAFT = exports.TEXT_REDRAFT = 'CAtomTextRedraft';
var VIDEO = exports.VIDEO = 'CAtomVideo';
var FORM_WRAPPER = exports.FORM_WRAPPER = 'CAtomFormWrapper';
var FORM_FIELDS_WRAPPER = exports.FORM_FIELDS_WRAPPER = 'CAtomFormFieldsWrapper';